import React from "react";
import { useNavigate } from "react-router-dom";
import { LOGIN } from "../enums/UrlPaths";
export const PageTagContext = React.createContext();

export default function PageTag({ children }) {
  const [tag, setTag] = React.useState(null);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (localStorage.length <= 1) {
      navigate(LOGIN);
    }
  }, [navigate]);

  function setCurrentTag(value) {
    setTag(value);
  }

  async function getCurrentTag() {
    return tag;
  }

  const values = { setCurrentTag, getCurrentTag };

  return (
    <PageTagContext.Provider value={values}>{children}</PageTagContext.Provider>
  );
}
